import messages from "../../../../locale/messages";
import {
  containsMalicious,
  inputDescLimit,
} from "../../../../helpers/textRestriction";

const validate = (values) => {
  const errors = {};

  if (!values.cancellationInfo) {
    errors.cancellationInfo = messages.required;
  } else if (values.cancellationInfo && values.cancellationInfo.trim() == "") {
    errors.cancellationInfo = messages.required;
  } else if (values?.cancellationInfo?.length > inputDescLimit) {
    errors.cancellationInfo = messages.descriptionFieldRestriction;
  } else if (containsMalicious(values.cancellationInfo)) {
    errors.cancellationInfo = messages.invalidInput;
  }

  return errors;
};

export default validate;
